import {FemaGoModal, DateBoxField, Alert, Select} from 'app-ui-componentlibrary';
import _ from 'lodash';
import React, {useState} from 'react';
import {Header, Grid, Dropdown, Form} from 'semantic-ui-react';

const FundingOpportunityCommitmentDetails = ({
  isEditable,
  detailsData,
  region,
  handleRegionChange,
  regionErrorMsg,
}) => {
  const REGIONS = ['HQ', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'];

  const regionOptions = _.concat(
    [{key: -1, text: null, value: null}],
    REGIONS.map((str, index) => ({
      key: index.toString(),
      text: str,
      value: index,
    }))
  );

  return (
    <Grid>
      <Grid.Row columns={2}>
        <Grid.Column width="8" verticalAlign="middle">
          Commitment number: {_.get(detailsData, 'commitmentNumberId', 'N/A')}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={2}>
        <Grid.Column width="8" verticalAlign="middle">
          Sequence number: {_.get(detailsData, 'commitmentLineNumber', 'N/A')}
        </Grid.Column>
        <Grid.Column width="8" verticalAlign="middle">
          Object class code: {_.get(detailsData, 'commitmentObjectCode', 'N/A')}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={2}>
        <Grid.Column width="8" verticalAlign="middle">
          ACCS code: {_.get(detailsData, 'accsline', 'N/A')}
        </Grid.Column>
        <Grid.Column width="8" verticalAlign="middle">
          Project code:{' '}
          {_.get(detailsData, 'commitmentProjectCode', 'N/A') === null
            ? 'N/A'
            : _.get(detailsData, 'commitmentProjectCode', 'N/A')}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={2}>
        <Grid.Column width="8" verticalAlign="middle">
          Fiscal year: {_.get(detailsData, 'commitmentBudgetFiscalYear', 'N/A')}
        </Grid.Column>
        <Grid.Column width="8" verticalAlign="middle">
          Fund function code: {_.get(detailsData, 'commitmentFundType', 'N/A')}
        </Grid.Column>
      </Grid.Row>

      <Grid.Row columns={2}>
        <Grid.Column width="8" verticalAlign="middle">
          Fund code: {_.get(detailsData, 'commitmentFundCode', 'N/A')}
        </Grid.Column>
        <Grid.Column width="8" verticalAlign="middle">
          Commitment start date: {_.get(detailsData, 'commitmentStartDate', 'N/A')}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={2}>
        <Grid.Column width="8" verticalAlign="middle">
          Finance program code:{' '}
          {_.get(detailsData, 'commitmentFinanceProgramCode', 'N/A')}
        </Grid.Column>
        <Grid.Column width="8" verticalAlign="middle">
          Commitment end date: {_.get(detailsData, 'commitmentEndDate', 'N/A')}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={2}>
        <Grid.Column width="8" verticalAlign="middle">
          Organization code: {_.get(detailsData, 'commitmentOrganizationCode', 'N/A')}
        </Grid.Column>
        <Grid.Column width="8" verticalAlign="middle">
          Commitment amount: {_.get(detailsData, 'commitmentAmount', 'N/A')}
        </Grid.Column>
      </Grid.Row>

      <Grid.Row columns={2}>
        <Grid.Column width="8" verticalAlign="middle" className="regionSelect">
          {isEditable ? (
            <Select
              id="region"
              title="region"
              name="region"
              label="Region:"
              options={regionOptions}
              value={region}
              handleChange={(e) => handleRegionChange(e.target.value)}
              errorMessages={[regionErrorMsg]}
              displayError={!_.isEmpty(regionErrorMsg)}
            />
          ) : (
            <>{`Region: ${_.get(detailsData, 'commitmentRegion', 'N/A')}`}</>
          )}
        </Grid.Column>
        <Grid.Column width="8" verticalAlign="middle">
          Available amount: {_.get(detailsData, 'commitmentAvailableAmount', 'N/A')}
        </Grid.Column>
      </Grid.Row>
      {isEditable ? (
        ''
      ) : (
        <Grid.Row columns={2}>
          <Grid.Column width="8" verticalAlign="middle">
            POP amendment cutoff date:{' '}
            {_.get(detailsData, 'popAmendmentCutoffDate', 'N/A') === ''
              ? 'N/A'
              : _.get(detailsData, 'popAmendmentCutoffDate', 'N/A')}
          </Grid.Column>
          <Grid.Column width="8" verticalAlign="middle">
            Period of availability end date:{' '}
            {_.get(detailsData, 'appropriationEndDate', 'N/A') === ''
              ? 'N/A'
              : _.get(detailsData, 'appropriationEndDate', 'N/A')}{' '}
          </Grid.Column>
        </Grid.Row>
      )}
    </Grid>
  );
};
export default FundingOpportunityCommitmentDetails;
